import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import { tuiDefaultProp } from '@taiga-ui/cdk';

class TuiRadioGroupComponent {
    constructor() {
        this.name = `tui-radio-group-${TuiRadioGroupComponent.index++}`;
    }
}
TuiRadioGroupComponent.index = 0;
TuiRadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TuiRadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiRadioGroupComponent, selector: "tui-radio-group", inputs: { name: "name" }, ngImport: i0, template: "<ng-content></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush });
__decorate([
    tuiDefaultProp()
], TuiRadioGroupComponent.prototype, "name", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-radio-group',
                    templateUrl: './radio-group.template.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { name: [{
                type: Input
            }] } });

class TuiRadioGroupModule {
}
TuiRadioGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiRadioGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupModule, declarations: [TuiRadioGroupComponent], exports: [TuiRadioGroupComponent] });
TuiRadioGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiRadioGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiRadioGroupComponent],
                    exports: [TuiRadioGroupComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiRadioGroupComponent, TuiRadioGroupModule };
